<div class="nsc-page-title" *ngIf="content.pageTitle">
  <h2>{{ content.pageTitle }} </h2>
  <div *ngIf="content.pageTitle == 'Order a Transcript'">
    <button mat-raised-button id="schoolselect_addprocess" class="nsc-button" color="primary"
      type="button" (click)="redirectToProcessFlowLink()">Learn How the Process Works
      <mat-icon aria-hidden="true">chevron_right</mat-icon></button>
  </div>
  <p   *ngIf="content.recipient"><strong>Send To:</strong> {{content.recipient}}</p>
  <nsc-spacer size="md"></nsc-spacer>
</div>